/* Auth API client. Uses cookies (credentials: 'include') for all requests. */
import axios from 'axios';

const BASE = process.env.REACT_APP_BACKEND_URL;
const client = axios.create({ baseURL: `${BASE}/api/auth`, withCredentials: true });

export function formatApiErrorDetail(detail) {
  if (detail == null) return 'Something went wrong. Please try again.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e))).filter(Boolean).join(' ');
  if (detail && typeof detail.msg === 'string') return detail.msg;
  return String(detail);
}

export const authApi = {
  me:          ()             => client.get('/me').then((r) => r.data),
  login:       (body)         => client.post('/login', body).then((r) => r.data),
  register:    (body)         => client.post('/register', body).then((r) => r.data),
  logout:      ()             => client.post('/logout').then((r) => r.data),
  forgot:      (email)        => client.post('/forgot-password', { email }).then((r) => r.data),
  reset:       (token, np)    => client.post('/reset-password', { token, new_password: np }).then((r) => r.data),
  googleSession:(session_id)  => client.post('/google/session', { session_id }).then((r) => r.data),
  refresh:     ()             => client.post('/refresh').then((r) => r.data),
  // admin
  listUsers:   (status)       => client.get('/admin/users', { params: status ? { status_filter: status } : {} }).then((r) => r.data),
  decideUser:  (user_id, decision) => client.post('/admin/users/decide', { user_id, decision }).then((r) => r.data),
  listInvites: ()             => client.get('/admin/invites').then((r) => r.data),
  createInvite:(body)         => client.post('/admin/invites', body).then((r) => r.data),
  revokeInvite:(code)         => client.delete(`/admin/invites/${code}`).then((r) => r.data),
  // access codes (4-digit email+code login)
  codeLogin:        (body)        => client.post('/code/login', body).then((r) => r.data),
  listAccessCodes:  ()            => client.get('/code/admin/list').then((r) => r.data),
  createAccessCode: (body)        => client.post('/code/admin/create', body).then((r) => r.data),
  updateAccessCode: (id, body)    => client.patch(`/code/admin/${id}`, body).then((r) => r.data),
  deleteAccessCode: (id)          => client.delete(`/code/admin/${id}`).then((r) => r.data),
};
